;(() => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    let firstTag = document.querySelector('script');
    firstTag.parentNode.insertBefore(tag, firstTag);

    function onYouTubeIframeAPIReady() {
        let player = new YT.Player('yt-video', {
            width: 1280,
            height: 720,
            videoId: 'pciw1jScua4',
            events: {
                'onReady': (e) => {
                    // e.target.playVideo();
                }
            }
        })
    }

    tag.onload = () => {
        YT.ready(onYouTubeIframeAPIReady);
    }
})()